import { render, staticRenderFns } from "./ValueEditor.vue?vue&type=template&id=5bef9ff4&"
import script from "./ValueEditor.vue?vue&type=script&lang=js&"
export * from "./ValueEditor.vue?vue&type=script&lang=js&"
import style0 from "./ValueEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports